import { createAutocompleteOptionsLoader } from "~/utils/Forms/Autocomplete";
import { FormKitNode } from "@formkit/core";

/**
 * When an autocomplete input has an optionsSource property, this plugin will add an options property to the node.
 * The options property will be a function that returns a promise that resolves to an array of options.
 */
const plugin = (node: FormKitNode) => {
  if (node.type === "input" && node.props.type === "autocomplete") {
    // Add properties to the base node
    node.addProps(["optionsSource"]);
    node.addProps(["searchProps"]);
    node.addProps(["optionsLabelTemplate"]);
    const rootNode = node.at("$root");

    // Set the loaders if these properties are on the node
    if (node.props.optionsSource) {
      node.props.options = createAutocompleteOptionsLoader(
        node.props.optionsSource,
        rootNode?.type === "group" ? rootNode : undefined,
        {
          optionsLabelTemplate:
            node.props?.optionsLabelTemplate || "{{ name }}",
          searchProps: node.props?.searchProps || ["*name*"]
        }
      );
    }
  }
};

export default plugin;
